import React from 'react';
import cn from 'classnames';
import styles from './index.module.scss';

import { useEcomPlatform } from 'utils/hooks';
import { ReactComponent as ShopifyIcon } from 'assets/img/ecomm-platforms/shopify.svg';
import { ReactComponent as WoocommerceIcon } from 'assets/img/ecomm-platforms/woocommerce.svg';
import { ReactComponent as BigcommerceIcon } from 'assets/img/ecomm-platforms/bigcommerce.svg';

/**
 * @type {Record<import("utils/types").EcommPlatformSource, React.FC>}
 */
const LOGO_MAP = {
  SHOPIFY: ShopifyIcon,
  WOOCOMMERCE: WoocommerceIcon,
  BIGCOMMERCE: BigcommerceIcon
};

/**
 * @param {Object} props
 * @param {import("utils/types").EcommPlatformSource} props.source
 * @param {string} props.className
 */
export default function Icon({ source = '', className = '' }) {
  const { ecommPlatformSource } = useEcomPlatform();

  const Logo = LOGO_MAP[source || ecommPlatformSource];

  if (!Logo) return null;

  return <Logo className={cn(styles.icon, className)} />;
}
